import { ServiceVariation } from "@/services/backend/omni/servicevariation/types/service-variation";
import { useEffect } from "react";
import { useOmniPositionsBaseDataShowForQuery } from "../api/base-data-api";
import {
  defaultPositionBaseData,
  PositionOptions,
  positionOptionsByAvailability,
} from "../types/position-base-data";

/**
 * usePositionOptions returns the options to add positions with at each
 * place of a document, from the positions base data the backend
 * resolves for the company, service kind and service variation, see
 * `positions.BaseDataService.ShowFor`: the base data of the service variation,
 * otherwise the default of the service kind. Without either, and while
 * it loads, only the generic {@link defaultPositionBaseData} are offered.
 */
export function usePositionOptions(
  companyId: string,
  serviceKind: string,
  serviceVariation: ServiceVariation,
): PositionOptions {
  // currentData belongs to the current arguments: a changed service variation must not
  // keep offering the options of the previous one.
  const { currentData: data, error } = useOmniPositionsBaseDataShowForQuery({
    companyId,
    serviceKind,
    serviceVariation,
  });

  const missing =
    error !== undefined && "status" in error && error.status === 404;
  useEffect(() => {
    if (error && !missing) {
      console.error("loading the position options failed", error);
    }
  }, [error, missing]);

  return positionOptionsByAvailability(
    data?.options ?? defaultPositionBaseData,
  );
}
